import { useEffect, useState } from "react";
import { TARGET_DATE_UTC } from "../config";

const pad = (n) => String(n).padStart(2, "0");

export default function Countdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, TARGET_DATE_UTC - now);
  const units = [
    { label: "Days", value: String(Math.floor(diff / 86400000)) },
    { label: "Hours", value: pad(Math.floor(diff / 3600000) % 24) },
    { label: "Minutes", value: pad(Math.floor(diff / 60000) % 60) },
    { label: "Seconds", value: pad(Math.floor(diff / 1000) % 60) },
  ];

  return (
    <div data-testid="countdown-timer" className="flex items-stretch justify-center gap-2 sm:gap-4">
      {units.map((u, i) => (
        <div key={u.label} className="flex items-center gap-2 sm:gap-4">
          <div
            data-testid={`countdown-${u.label.toLowerCase()}`}
            className="w-[74px] rounded-2xl border border-white/10 bg-white/[0.04] px-2 py-4 text-center shadow-[0_0_40px_rgba(0,245,212,0.08)] backdrop-blur-xl sm:w-28 sm:py-6"
          >
            <div className="font-mono-x text-3xl font-extrabold tabular-nums text-slate-50 sm:text-5xl">{u.value}</div>
            <div className="mt-1 font-mono-x text-[10px] uppercase tracking-[0.25em] text-[#00F5D4] sm:text-xs">{u.label}</div>
          </div>
          {i < units.length - 1 && (
            <span className="animate-glow-pulse font-mono-x text-2xl text-[#FF2B4A] sm:text-3xl">:</span>
          )}
        </div>
      ))}
    </div>
  );
}
